import React from "react";
import { Link } from "react-router-dom";
import TeamData from "../../data/casestudy/TeamData.json";
import Tilty from "react-tilty";

const allData = TeamData;

const AboutProp = () => {
  const CaseLeftThumb = ({ data }) => {
    return (
      <>
        <div className="col-lg-6">
          <div className={`case-study-featured-thumb thumb-${data.id}`}>
            <Tilty perspective={2000}>
              <img
                src={process.env.PUBLIC_URL + data.thumb}
                alt="Progress Tracker"
              />
            </Tilty>
          </div>
        </div>
        <div className="col-xl-5 col-lg-6 offset-xl-1">
          <div className="case-study-featured">
            <div className="section-heading heading-left">
              <span className="subtitle"></span>
              <h2 className="title">{data.title}</h2>
              <p>{data.excerpt}</p>
              <Link
                to={process.env.PUBLIC_URL + `/login`}
                className="axil-btn btn-primary try-free-btn">
                Try For Free
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  };

  const CaseRightThumb = ({ data }) => {
    return (
      <>
        <div className="col-lg-6 offset-xl-1 order-lg-2">
          <div className={`case-study-featured-thumb thumb-${data.id}`}>
            <Tilty perspective={2000}>
              <img src={process.env.PUBLIC_URL + data.thumb} alt="Case Study" />
            </Tilty>
          </div>
        </div>
        <div className="col-lg-5 order-lg-1">
          <div className="case-study-featured">
            <div className="section-heading heading-left">
              <span className="subtitle">{data.subtitle}</span>
              <h2 className="title">{data.title}</h2>
              <p>{data.excerpt}</p>
              <Link
                to={process.env.PUBLIC_URL + `/login`}
                className="axil-btn btn-primary try-free-btn">
                Try For Free
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {allData.map((data) => (
        <div className="row" key={data.id}>
          {data.id % 2 === 0 ? (
            <CaseRightThumb data={data} />
          ) : (
            <CaseLeftThumb data={data} />
          )}
        </div>
      ))}
    </>
  );
};

export default AboutProp;
